import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

const guides = [
  { name: 'Complete Spreadsheet Guide', url: '/sugargoo-spreadsheet-guide' },
  { name: 'Sugargoo Review 2026', url: '/sugargoo-review' },
  { name: 'Shipping Cost Guide', url: '/sugargoo-shipping-guide' },
  { name: 'Coupons & Discounts', url: '/sugargoo-coupon-guide' },
  { name: 'Warehouse Guide', url: '/sugargoo-warehouse-guide' },
  { name: 'Best Spreadsheets 2026', url: '/best-sugargoo-spreadsheet' },
  { name: 'Expert Tips & Tricks', url: '/sugargoo-spreadsheet-tips' },
  { name: 'Beginner\'s Guide', url: '/sugargoo-spreadsheet-beginners' },
  { name: 'Top Product Finds', url: '/sugargoo-product-finds' },
];

export default function Navbar() {
  const [catOpen, setCatOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const [mobileGuideOpen, setMobileGuideOpen] = useState(false);
  const catRef = useRef<HTMLDivElement>(null);
  const guideRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (catRef.current && !catRef.current.contains(e.target as Node)) setCatOpen(false);
      if (guideRef.current && !guideRef.current.contains(e.target as Node)) setGuideOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const navBg = scrolled
    ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
    : 'bg-transparent';
  const btnBase = scrolled
    ? 'bg-background-100 text-foreground-800 hover:bg-background-200 border border-background-200'
    : 'bg-background-50/70 text-foreground-800 hover:bg-background-50 border border-background-200/60';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[4.5rem]">
          {/* Logo */}
          <Link
            to="/"
            className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-tight whitespace-nowrap"
          >
            Sugargoo<span className="text-primary-500">Sheet</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-2">
            <Link
              to="/"
              className="px-4 py-2 rounded-full text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-all duration-200 whitespace-nowrap"
            >
              Home
            </Link>

            {/* Shopping Guides Dropdown */}
            <div className="relative" ref={guideRef}>
              <button
                onClick={() => { setGuideOpen(!guideOpen); setCatOpen(false); }}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${btnBase}`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-book-open-line text-sm"></i>
                </span>
                Shopping Guides
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${guideOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              {guideOpen && (
                <div className="absolute right-0 mt-2 w-64 bg-background-50 border border-background-200 rounded-lg overflow-hidden shadow-lg z-50">
                  <div className="max-h-72 overflow-y-auto py-1">
                    {guides.map((g) => (
                      <Link
                        key={g.name}
                        to={g.url}
                        className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150 whitespace-nowrap"
                        onClick={() => setGuideOpen(false)}
                      >
                        {g.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Categories Dropdown */}
            <div className="relative" ref={catRef}>
              <button
                onClick={() => { setCatOpen(!catOpen); setGuideOpen(false); }}
                className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${btnBase}`}
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-grid-line text-sm"></i>
                </span>
                Categories
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${catOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              {catOpen && (
                <div className="absolute right-0 mt-2 w-64 bg-background-50 border border-background-200 rounded-lg overflow-hidden shadow-lg z-50">
                  <div className="max-h-80 overflow-y-auto py-1">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150 whitespace-nowrap"
                        onClick={() => setCatOpen(false)}
                      >
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap ml-2"
            >
              Sugargoo Spreadsheet
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </div>

          {/* Mobile Controls */}
          <div className="flex md:hidden items-center gap-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
            >
              Shop
              <span className="w-3 h-3 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-[10px]"></i>
              </span>
            </a>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200"
              aria-label="Toggle menu"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-800`}></i>
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <div className="px-4 py-4 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-primary-50 transition-colors duration-150"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-home-line text-base text-primary-500"></i>
              </span>
              Home
            </Link>

            {/* Mobile Shopping Guides */}
            <div>
              <button
                onClick={() => setMobileGuideOpen(!mobileGuideOpen)}
                className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-primary-50 transition-colors duration-150"
              >
                <span className="flex items-center gap-3">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-book-open-line text-base text-accent-500"></i>
                  </span>
                  Shopping Guides
                </span>
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${mobileGuideOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              {mobileGuideOpen && (
                <div className="ml-8 space-y-0.5 border-l-2 border-primary-100 pl-4">
                  {guides.map((g) => (
                    <Link
                      key={g.name}
                      to={g.url}
                      onClick={() => setMobileOpen(false)}
                      className="block px-3 py-2.5 text-sm text-foreground-600 hover:text-primary-600 hover:bg-primary-50/50 rounded-md transition-colors duration-150"
                    >
                      {g.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            {/* Mobile Categories */}
            <div>
              <button
                onClick={() => setMobileCatOpen(!mobileCatOpen)}
                className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-lg text-sm font-medium text-foreground-800 hover:bg-primary-50 transition-colors duration-150"
              >
                <span className="flex items-center gap-3">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-grid-line text-base text-secondary-500"></i>
                  </span>
                  Product Categories
                </span>
                <span className={`w-4 h-4 flex items-center justify-center transition-transform duration-200 ${mobileCatOpen ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </span>
              </button>
              {mobileCatOpen && (
                <div className="ml-8 space-y-0.5 border-l-2 border-secondary-100 pl-4">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center justify-between px-3 py-2.5 text-sm text-foreground-600 hover:text-secondary-600 hover:bg-secondary-50/50 rounded-md transition-colors duration-150"
                    >
                      <span>{cat.name}</span>
                      <span className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-external-link-line text-xs text-foreground-400"></i>
                      </span>
                    </a>
                  ))}
                </div>
              )}
            </div>

            <div className="pt-4 border-t border-background-200 mt-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setMobileOpen(false)}
                className="flex items-center justify-center gap-2 w-full px-4 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200"
              >
                Sugargoo Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}